import { render } from "./icon-xls.vue?vue&type=template&id=baaa3b34"
const script = {}

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__